<template>
  <div style='position: relative'>
    <b-loading :active='items === null' :is-full-page='false' />

    <div class='actions'>
      <div class='search'>
        <b-field style='width: 400px'>
          <b-input
            v-model='query'
            placeholder='Rechercher...'
            icon='search'
            size='is-small'
            expanded
            :disabled='!items || items.length === 0'
          />
          <button v-if='query' class='button is-small' @click="query = ''">
            <b-icon icon='times-circle' size='is-small' />
            <span>Annuler</span>
          </button>
        </b-field>
      </div>

      <div class='export-csv' >
        <button class='button is-small' @click='exportCSV(filteredItems)'>
          <b-icon icon='arrow-down' size='is-small' />
          <span>Export CSV</span>
        </button>
      </div>
      <div class='poser-question' v-if='site'>
        <button class='button is-small' @click='showModal = true'>
          <b-icon icon='plus' size='is-small' />
          <span>Poser une question</span>
        </button>
      </div>
    </div>

    <div class='include-checkboxes'>
      <b-checkbox v-if='site' v-model='includeSite' size='is-small'>
        Inclure tout <em v-text='site.name' />
      </b-checkbox>
      &nbsp;&nbsp;
      <b-checkbox
        v-if='portefeuille'
        v-model='includePortefeuille'
        size='is-small'
      >
        Inclure tout <em v-text='portefeuille.name' />
      </b-checkbox>
    </div>

    <div v-if='query'>
      <h1 class='is-size-4'>Résultats de la recherche</h1>

      <b-message v-if='filteredItems.length === 0'>
        Aucun résultat trouvé.
      </b-message>
    </div>

    <b-message v-if='items && items.length === 0'>
      Aucune question n'a été posée.
    </b-message>

    <!-- :default-sort="['status', 'desc']" -->
    <!-- v-if='filteredItems.length > 0' -->
    <b-table
      :data='filteredItems'
      :mobile-cards='false'
      :default-sort="['date', 'desc']"
      detailed
    >
      <!-- /* Was used for per column filter, useless now */
      <template slot='top-row' slot-scope='fields'>
        <b-td v-for='field in fields' :key='field.key'>
            <input v-model='filters[field.key]' :placeholder='field.label'>
        </b-td>
      </template>
    -->
      <template slot-scope='props'>

        <b-table-column field='chrono' label='Chrono Question' sortable>
          {{ props.row.chrono }}
        </b-table-column>
        <b-table-column field='title' label='Objet' sortable>
          {{ props.row.title }}
        </b-table-column>

        <b-table-column field='date' label='Date' sortable>
          {{ props.row.date | moment('DD/MM/YYYY') }}
        </b-table-column>

        <b-table-column field='status' label='État' sortable :custom-sort='sortByStatus'>
          <div class='question-status'>
            {{ props.row.workflowState }}
          </div>
        </b-table-column>

        <b-table-column field='bien' label='Bien' sortable>
          {{ bienName(props.row.bien) }}
        </b-table-column>

        <b-table-column field='site' label='Site' sortable>
          {{ siteName(props.row.bien) }}
        </b-table-column>

        <b-table-column field='theme' label='Theme' sortable :custom-sort='sortByTheme'>
          {{ props.row.theme.name }}
        </b-table-column>

        <b-table-column field='auteur' label='Auteur' sortable>
          {{ props.row.questionAuteur.name }}
        </b-table-column>

      </template>

      <template slot='detail' slot-scope='props'>
        <p class='info'>Posée le {{ props.row.date | moment('DD/MM/YYYY') }}</p>
        <p class='question'>
          <strong>{{ props.row.question }}</strong>
        </p>
        <div
          v-if='props.row.reponse && props.row.reponseAuteur'
          class='reponse'
        >
          <p class='info'>
            Réponse envoyée le
            {{ props.row.reponseDate | moment('DD/MM/YYYY') }} par
            <em>{{ props.row.reponseAuteur.name }}</em>
          </p>
          <p class='reponse'>
            <strong>{{ props.row.reponse }}</strong>
          </p>
        </div>
        <div
          v-if='props.row.complement && props.row.complementAuteur'
          class='reponse'
        >
          <p class='info'>
            Complément de réponse envoyé le
            {{ props.row.complementDate | moment('DD/MM/YYYY') }} par
            <em>{{ props.row.complementAuteur.name }}</em>
          </p>
          <p class='reponse'>
            <strong>{{ props.row.complement }}</strong>
          </p>
        </div>
      </template>
    </b-table>

    <b-modal :active.sync='showModal' has-modal-card>
      <PortefeuilleQuestionModal @sent='getData' />
    </b-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import PortefeuilleQuestionModal from '@/components/Portefeuille/QuestionModal'

export default {
  props: {
    includePortefeuilleData: Boolean,
  },
  components: {
    PortefeuilleQuestionModal,
  },
  data () {
    return {
      query: '',
      showModal: false,
      includeSite: false,
      includePortefeuille: this.includePortefeuilleData || false,
      // fields: [
      //   /* Was used for per column filter, useless now */
      //   { key: 'title', label: 'Objet' },
      //   { key: 'date', label: 'Date' },
      //   { key: 'status', label: 'État' },
      //   { key: 'bien', label: 'Bien' },
      //   { key: 'site', label: 'Site' },
      //   { key: 'theme', label: 'Theme' },
      //   { key: 'auteur', label: 'Auteur' },
      // ],
      // filters: {
      //   /* Was used for per column filter, useless now */ title: '',
      //   date: '',
      //   status: '',
      // },
    }
  },
  computed: {
    ...mapState({
      biens: (state) => state.inv.biens,
    }),
    items () {
      if (!this.$store.state.inv.questions) return null

      if (!this.includeSite && !this.includePortefeuille) {
        return this.$store.state.inv.questions.filter(
          (i) => i.bien === +this.$route.params.bien
        )
      }

      if (this.includeSite) {
        const bienIds = this.biens
          .filter((i) => i.site === +this.$route.params.site)
          .map((i) => i.id)
        return this.$store.state.inv.questions.filter(
          (i) => bienIds.indexOf(i.bien) !== -1
        )
      }

      return this.$store.state.inv.questions
    },
    filteredItems () {
      if (!this.items || this.items.length === 0) return []
      if (!this.query) return this.items

      const reg = new RegExp(
        '' + this.query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'),
        'i'
      )

      const filtered = this.items.filter((item) => {
        if (
          !Object.keys(this.filters).length > 0 &&
          Object.keys(this.filters).every((key) =>
            String(item[key]).includes(this.filters[key])
          )
        ) {
          return false /* Was used for per column filter, useless now */
        }
        if (item.title.match(reg)) return true
        if (item.chrono.match(reg)) return true
        if (item.question.match(reg)) return true
        if (item.reponse && item.reponse.match(reg)) return true
        if (item.complement && item.complement.match(reg)) return true
        if (item.date && item.date.match(reg)) return true
        if (item.questionAuteur.name && item.questionAuteur.name.match(reg)) return true
        if (item.theme.name && item.theme.name.match(reg)) return true
        return false
      })

      return filtered.length > 0
        ? filtered
        : [{ title: '', question: '', reponse: '', complement: '' }]
    },
    portefeuille () {
      if (!this.$route.params.portefeuille) return
      const value = this.biens.find(
        (i) => i.portefeuille === +this.$route.params.portefeuille
      )
      return value
        ? {
          id: value.portefeuille,
          name: value.portefeuilleName,
        }
        : null
    },
    site () {
      if (!this.$route.params.site) return
      const value = this.biens.find((i) => i.site === +this.$route.params.site)
      return value
        ? {
          id: value.site,
          name: value.siteName,
        }
        : null
    },
  },
  watch: {
    '$route.params.bien' () {
      this.query = ''
    },
  },
  created () {
    window.addEventListener('refreshQuestions', this.getData)
  },
  destroyed () {
    window.removeEventListener('refreshQuestions', this.getData)
  },
  methods: {
    async getData () {
      this.$store.dispatch('inv/getQuestions', this.$route.params.portefeuille)
    },
    bienName (id) {
      const item = _.find(this.biens, { id })
      return item ? item.name : null
    },
    siteName (id) {
      const item = _.find(this.biens, { id })
      return item ? item.siteName : null
    },
    sortByStatus (a, b, isAsc) {
      if (isAsc) {
        return a.workflowState.localeCompare(b.workflowState)
      } else {
        return b.workflowState.localeCompare(a.workflowState)
      }
    },
    sortByTheme (a, b, isAsc) {
      if (isAsc) {
        return a.theme.name.localeCompare(b.theme.name)
      } else {
        return b.theme.name.localeCompare(a.theme.name)
      }
    },
    exportCSV (data) {
      let csv = ''

      const fieldNames = ['id', 'chrono', 'question', 'workflowState', 'bien', 'site', 'theme', 'questionAuteur', 'reponse', 'reponseDate', 'reponseAuteur']

      const header = 'QUESTION;CHRONO QUESTION;OBJET;ETAT;BIEN;SITE;THEME;AUTEUR(QUESTION);REPONSE;REPONSEDATE;AUTEUR(REPONSE)\n'
      csv += header

      data.forEach(obj => {
        let site = ''

        const row = fieldNames.map(key => {
          let value = obj[key]

          if (key === 'bien') {
            value = this.bienName(value)
            site = this.siteName(value)
          }

          if (key === 'site') {
            value = site
          }

          if (key === 'theme' && value !== null && value !== undefined) {
            value = value.name
          }

          if (key === 'questionAuteur' && value !== null && value !== undefined) {
            value = value.name
          }

          if (key === 'reponseAuteur' && value !== null && value !== undefined) {
			console.log(value)
            value = value.name
          }

          if (typeof value === 'string' && value.includes(';')) {
            return `"${value}"` // Enclose in double quotes if value contains a comma
          }
          return value
        }).join(';')

        csv += row + '\n'
      })

      const anchor = document.createElement('a')
      anchor.href = 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURIComponent(csv)
      anchor.target = '_blank'
      anchor.download = 'exportCSV.csv'
      anchor.click()
    },
  },
}
</script>

<style lang='scss' scoped>
h1 {
  margin: 1.5em 0 0.5em;
}
.info {
  font-size: 0.85em;
  margin-bottom: 0.25em;
}
p.question {
  margin-bottom: 0.5em;
}
div.reponse {
  border-top: 1px solid #f5f5f5;
  padding: 1em 0;
}
p.question,
p.reponse {
  white-space: pre-line;
}
.icon {
  opacity: 0.5;
  margin-right: 0.25em;
  font-size: 0.8em;
}
.question-status {
  position: relative;
  font-size: 0.8em;
  padding-left: 20px;
  padding-top: 5px;
  line-height: 1.2;
  .icon {
    position: absolute;
    top: 4px;
    left: 0;
  }
}
.include-checkboxes {
  float: right;
  margin: 0.5em 0 0.25em;
}
</style>
